import React from 'react';
import styled from 'styled-components/macro';


const PlayIcon = (props) => {
    return (
        <Container {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="168" height="168" viewBox="0 0 168 168" fill="none">
                <circle cx="84" cy="84" r="84" fill="#183029" fillOpacity="0.74" />
                <path d="M122 84.5L65.75 116.976L65.75 52.024L122 84.5Z" fill="#ADCAB8" />
            </svg>
        </Container>
    );
};


export default PlayIcon;


const Container = styled.span`
    display: inline-block;
    vertical-align: middle;
    height: 1em;
    
    svg {
        height: 100%;
        width: auto;
    }
`;
